import { useEffect, useState } from 'react'
import { onAuthStateChanged, User } from 'firebase/auth'
import { useAuth } from '../context/AuthContext'
import { useQueryClient } from '@tanstack/react-query'

export default function useFirebaseAuthentication() {
	const auth = useAuth()
	const [authUser, setAuthUser] = useState<User | null>()
	const [loading, setLoading] = useState(true)
	const queryClient = useQueryClient()

	useEffect(() => {
		const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
			setAuthUser(currentUser)
			setLoading(false)
			if (!currentUser) {
				queryClient.removeQueries()
			}
		})

		return () => unsubscribe() // Cleanup on unmount
	}, [])

	return {
		loading,
		authUser,
	}
}
